import {JsonProperty} from 'json-typescript-mapper';
import {Marketday} from './marketday.model';
import {Contact} from './contact.model';
import {Marketdate} from './marketdate.model';

export class OpenPayment {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty({clazz: Marketday, name: 'marketday'})
  public marketday?: Marketday;

  @JsonProperty({clazz: Contact, name: 'merchant'})
  public merchant?: Contact;

  @JsonProperty({clazz: Marketdate, name: 'marketdate'})
  public marketdate?: Marketdate;

  @JsonProperty('amount')
  public amount?: number;

  @JsonProperty('date')
  public date?: string;

  @JsonProperty('status')
  public status?: string;

  @JsonProperty({clazz: Contact, name: 'updatedBy'})
  public updatedBy?: Contact;

  @JsonProperty('comment')
  public comment?: string;

  @JsonProperty('branchComment')
  public branchComment?: string;

  constructor() {
    this.id = void 0;
    this.marketday = void 0;
    this.merchant = void 0;
    this.marketdate = void 0;
    this.amount = void 0;
    this.date = void 0;
    this.status = void 0;
    this.updatedBy = void 0;
    this.comment = void 0;
    this.branchComment = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/open-payment.model.ts